import React, {useCallback, useRef, useEffect, useState} from "react";
import { Products } from "./Products";
import { Credits } from "./Credits";
import { Services } from "./Services";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { useCreditDispatch } from "../../stores/credit/credit.store";
import {nextPage, setAddress, setCity, setShipping} from "../../stores/credit/credit.reducer";
import { selectSubscription } from "../../stores/credit/credit.reducer";
import { setStarnetCity } from "../../stores/credit/credit.reducer";
import { setStarnetRegion } from "../../stores/credit/credit.reducer";
import { setStarnetAddress } from "../../stores/credit/credit.reducer";

import { useCreditSelector } from "../../stores/product/product.store";
import { Subscription } from '../../interfaces/product/product.interface';
import {SelectCustom} from "../Select";
import {environment} from "environments/environment";
import { updateCreditAvanseThunk } from "../../stores/credit/thunks/update-credit-avanse.thunk";

export const First = () => {
    const products = useCreditSelector((state: CreditState) => state.products);
    const translateText = useCreditSelector((state: CreditState) => state.text);

    const selectedMonth = useCreditSelector((state: CreditState) => state.selectMonth);
    const selectedSubscription = useCreditSelector((state: CreditState) => state.selectSubscription);
    const selectedZone = useCreditSelector(state => state.selectStarnetCity);
    const selectedRegion = useCreditSelector(state => state.selectStarnetRegion);
    const selectedAddress = useCreditSelector(state => state.selectStarnetAddress);
    const [zones, setZones] = useState<{ label: string; value: string }[]>([]);
    const avanse = useCreditSelector(state => state.avanse);
    const temp = 0;
    const lastSentSubscriptionId = useRef<number | null>(null);

    const dispatch = useCreditDispatch();
    const [external, setExternal] = useState(false);

    const isContinueDisabled = selectedMonth?.subscriptions?.length
    ? selectedSubscription?.id !== 0 &&
      !(
          selectedZone &&
          (selectedRegion || '').trim() &&
          (selectedAddress || '').trim()
      )
    : false;

    const next = () => {
        dispatch(nextPage());
    }

    const handleSubscriptionChange = (sub: Subscription | null) => {
        dispatch(selectSubscription(sub));
    };

    useEffect(() => {
        const subs = selectedMonth?.subscriptions;

        if (!subs || subs.length === 0) {
            if (selectedSubscription !== null) {
                dispatch(selectSubscription(null));
            }
            
            lastSentSubscriptionId.current = null;
            return;
        }

        const existsInNewList = subs.some(s => s.id === selectedSubscription?.id);

        if (!existsInNewList) {
            const defaultSub = subs.find(sub => sub.id === 0) || subs[0];
            dispatch(selectSubscription(defaultSub));
        }
    }, [selectedMonth]);


    useEffect(() => {
    if (!selectedMonth) return;

        const currentId = selectedSubscription?.id ?? null;
        if (lastSentSubscriptionId.current === currentId) return;

        lastSentSubscriptionId.current = currentId;

        dispatch(updateCreditAvanseThunk({
            avanse,
            temp
        }));
    }, [selectedMonth, selectedSubscription, avanse, temp]);

    useEffect(() => {
        fetch(environment.urls.credits.getCities, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ optionId: 6 })
        })
            .then(res => res.json())
            .then(data => {
                const zonesFormatted = data.map((city: any) => ({
                    label: city.name,
                    value: city.code
                }));
                setZones(zonesFormatted);
            })
            .catch(err => console.error('Error fetching cities:', err));
    }, []);

    const onChangeZone = (option: { label: string; value: string } | null) => {
        dispatch(setStarnetCity(option?.value || null));
    };

    useEffect(() => {
        products.items.map(product => {
            if(product.merchantExternal) setExternal(true)
        })
    }, [])

    return (
        <>
            <div className="mb-4 rounded-2xl bg-white p-5">
                <Products products={ products } />
            </div>
            {external ? <div className="mb-4 rounded-2xl bg-white p-5">
                {translateText.sender}
            </div> : <></>}
            <div className="mb-4">
                <Credits/>
            </div>

            {selectedMonth && selectedMonth.subscriptions && selectedMonth.subscriptions.length > 0 && (
                <div className="mb-4 rounded-2xl bg-white p-5">
                    <div className="mb-3 w-100 subscriptions-credit-notice">
                        <span className="notice">{translateText.noticeText}</span>{" "}
                        <span>{translateText.noticeSubscription}</span>
                    </div>
                    <div className="subscriptions-credit">
                        {selectedMonth.subscriptions.map(sub => (
                            <label
                                key={sub.id}
                                className="flex items-center mb-2 md:mb-3 md:w-[100%] cursor-pointer"
                            >
                               <input
                                    type="radio"
                                    id={`subscription-${sub.id}`}
                                    name="subscription"
                                    checked={selectedSubscription?.id === sub.id}
                                    onChange={() => handleSubscriptionChange(sub)}
                                    className="mr-5 subscription-credit-radio relative opacity-1"
                                />

                                <div className="flex flex-row items-start subscription-credit-name gap-2">
                                    {sub.name}
                                    {Number(sub.price) > 0 && (
                                        <span>({Number(sub.price).toFixed(0)} {translateText.leiMonth})</span>
                                    )}
                                </div>
                            </label>
                        ))}
                    </div>
                </div>
            )}

            {selectedMonth &&
                selectedMonth.subscriptions &&
                selectedMonth.subscriptions.length > 0 &&
                selectedSubscription?.id !== 0 && (
                <div className="mb-4 rounded-2xl bg-white p-5">
                    <div className="mb-3 w-100 subscriptions-location-header">
                        <h3 className="text-[#12100B] text-xl font-bold">
                            {translateText.locationHeader}
                        </h3>
                        <span className="text-[#949494] text-sm font-medium">
                          {translateText.locationCaption}
                        </span>
                    </div>
                    <div className="w-full mb-6">
                        <label htmlFor="region"
                               className="text-sm font-medium mb-3 block text-black">{ translateText.region }<span
                            className="text-red-500"> *</span></label>
                        <SelectCustom
                            options={zones}
                            onChange={(option) => dispatch(setStarnetCity(option?.label || null))}
                            value={selectedZone ? { label: selectedZone, value: selectedZone } : null}
                        />
                    </div>
                    {
                        selectedZone && <div>
                            <div className="w-full mb-6">
                                <label htmlFor="city"
                                       className="text-sm font-medium mb-3 block text-black">{ translateText.city }<span
                                    className="text-red-500"> *</span></label>
                                <input id="city"
                                       type="text"
                                       className="p-4 bg-light-gray w-full h-14 box-border border-none caret-yellow rounded-xl"
                                       value={selectedRegion || ''}
                                       onChange={(e) => dispatch(setStarnetRegion(e.target.value))}
                                />
                            </div>
                            <div className="w-full mb-6">
                                <label htmlFor="address"
                                       className="text-sm font-medium mb-3 block text-black">{ translateText.address }<span
                                    className="text-red-500"> *</span></label>
                                <input id="address"
                                       type="text"
                                       className="p-4 bg-light-gray w-full h-14 box-border border-none caret-yellow rounded-xl"
                                       value={selectedAddress || ''}
                                       onChange={(e) => dispatch(setStarnetAddress(e.target.value))}
                                />
                            </div>
                        </div>
                    }
                </div>
            )}

            {selectedMonth && (selectedMonth.requireServices?.length || selectedMonth.additionServices?.length) && <div className="mb-4 rounded-2xl bg-white p-5">
                <Services month={ selectedMonth }/>
            </div> }
            <button
                onClick={ () => next() }
                disabled={isContinueDisabled}
                className={ `w-full rounded-xl h-[56px] ${isContinueDisabled ? 'bg-light-dark-gray text-white' : 'bg-yellow text-dark-gray'} font-semibold mb-2` }>{ translateText.continue }
            </button>
        </>
    )
}